import React from "react";

export function BooksIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 5C4 4.46875 4.4375 4 5 4H7C7.53125 4 8 4.46875 8 5V7H4V5ZM4 8H8V16H4V8ZM4 17H8V19C8 19.5625 7.53125 20 7 20H5C4.4375 20 4 19.5625 4 19V17ZM9 5C9 4.46875 9.4375 4 10 4H12C12.5312 4 13 4.46875 13 5V7H9V5ZM9 8H13V16H9V8ZM9 17H13V19C13 19.5625 12.5312 20 12 20H10C9.4375 20 9 19.5625 9 19V17ZM15.3438 16.4062L14 11.2812V8.46875L17.125 7.625L19.1875 15.375L15.3438 16.4062ZM16.875 6.65625L14 7.4375V4.34375L15.125 4.0625C15.6562 3.90625 16.2188 4.21875 16.3438 4.75L16.875 6.65625ZM15.5938 17.3438L19.4375 16.3438L19.9375 18.25C20.0938 18.7812 19.7812 19.3125 19.25 19.4688L17.3438 19.9688C16.8125 20.125 16.25 19.8125 16.125 19.2812L15.5938 17.3438Z"
      />
    </svg>
  );
}
